import React, { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { SEO } from '../components/shared/SEO';
import { Header } from '../components/layout/Header';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { MobileDeliverToPill } from '../components/layout/MobileDeliverToPill';
import { Footer } from '../components/layout/Footer';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { PharmacistChat } from '../components/services/PharmacistChat';
import { PrescriptionDetailsModal } from '../components/prescription/PrescriptionDetailsModal';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { ChevronRightIcon, CheckCircleIcon, ClockIcon, PackageIcon, XCircleIcon, FilterIcon, SearchIcon } from 'lucide-react';
import { MobileInternalHeader } from '../components/layout/MobileInternalHeader';
import { PRODUCT_IMAGES } from '../data/productImages';
export function AllPrescriptionsPage() {
  const [selectedPrescription, setSelectedPrescription] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<{
    name: string;
  } | null>(null);
  const allPrescriptions = [{
    id: '#RX-2025-00123',
    date: '2024-01-15',
    status: 'delivered',
    items: [{
      name: 'Metformin 500mg',
      quantity: 60,
      price: 125.5,
      image: PRODUCT_IMAGES[0]
    }, {
      name: 'Lisinopril 10mg',
      quantity: 30,
      price: 120.0,
      image: PRODUCT_IMAGES[1]
    }],
    doctor: 'Dr. Sarah Ahmed',
    deliveryAddress: 'Riyadh, Al Malqa District, King Fahd Road, Building 123, Apartment 456, Postal Code: 12345',
    deliveryCoordinates: {
      lat: 24.7136,
      lng: 46.6753
    },
    paymentMethod: 'Credit Card',
    total: 245.5,
    prescriptionSource: 'cash' as const,
    trackingHistory: [{
      status: 'Delivered',
      timestamp: '2024-01-15T14:30:00',
      description: 'Package delivered successfully'
    }, {
      status: 'Out for Delivery',
      timestamp: '2024-01-15T10:00:00',
      description: 'Package is out for delivery'
    }, {
      status: 'In Transit',
      timestamp: '2024-01-15T08:00:00',
      description: 'Package is in transit to your location'
    }, {
      status: 'Processing',
      timestamp: '2024-01-14T16:00:00',
      description: 'Prescription verified and order is being prepared'
    }]
  }, {
    id: '#RX-2025-00122',
    date: '2024-01-10',
    status: 'ready',
    items: [{
      name: 'Atorvastatin 20mg',
      quantity: 30,
      price: 89.99,
      image: PRODUCT_IMAGES[2]
    }],
    doctor: 'Dr. Mohammed Ali',
    pickupBranch: {
      name: 'Innova Pharmacy - Riyadh Park',
      address: 'Riyadh Park Mall, Al Malaz District, Riyadh',
      coordinates: {
        lat: 24.7136,
        lng: 46.6753
      }
    },
    pickupTime: 'Today, 2:00 PM - 6:00 PM',
    paymentMethod: 'Cash on Delivery',
    total: 89.99,
    prescriptionSource: 'wasfaty' as const,
    wasfatyNumber: 'WF-2024-001234'
  }, {
    id: '#RX-2025-00121',
    date: '2024-01-05',
    status: 'in-progress',
    items: [{
      name: 'Insulin Glargine',
      quantity: 1,
      price: 356.0,
      image: PRODUCT_IMAGES[3]
    }, {
      name: 'Test Strips',
      quantity: 100,
      price: 100.0,
      image: PRODUCT_IMAGES[4]
    }],
    doctor: 'Dr. Fatima Hassan',
    deliveryAddress: 'Riyadh, Al Malqa District, King Fahd Road, Building 789, Floor 3',
    deliveryCoordinates: {
      lat: 24.7114,
      lng: 46.6747
    },
    paymentMethod: 'Mada',
    total: 456.0,
    prescriptionSource: 'insurance' as const,
    insuranceProvider: 'Bupa Arabia',
    trackingHistory: [{
      status: 'Processing',
      timestamp: '2024-01-05T14:00:00',
      description: 'Prescription received and under review'
    }]
  }, {
    id: '#RX-2025-00120',
    date: '2023-12-28',
    status: 'delivered',
    items: [{
      name: 'Aspirin 100mg',
      quantity: 90,
      price: 78.75,
      image: PRODUCT_IMAGES[0]
    }, {
      name: 'Vitamin D3',
      quantity: 60,
      price: 78.0,
      image: PRODUCT_IMAGES[1]
    }],
    doctor: 'Dr. Ahmed Hassan',
    deliveryAddress: 'Riyadh, Al Malqa District, King Fahd Road',
    deliveryCoordinates: {
      lat: 24.7136,
      lng: 46.6753
    },
    paymentMethod: 'Credit Card',
    total: 156.75,
    prescriptionSource: 'cash' as const,
    trackingHistory: [{
      status: 'Delivered',
      timestamp: '2023-12-28T15:30:00',
      description: 'Package delivered successfully'
    }, {
      status: 'Out for Delivery',
      timestamp: '2023-12-28T11:00:00',
      description: 'Package is out for delivery'
    }, {
      status: 'In Transit',
      timestamp: '2023-12-28T09:00:00',
      description: 'Package is in transit'
    }]
  }, {
    id: '#RX-2025-00119',
    date: '2023-12-20',
    status: 'delivered',
    items: [{
      name: 'Omeprazole 20mg',
      quantity: 30,
      price: 67.5,
      image: PRODUCT_IMAGES[2]
    }],
    doctor: 'Dr. Layla Mohammed',
    deliveryAddress: 'Riyadh, Al Malqa District, King Fahd Road',
    deliveryCoordinates: {
      lat: 24.7136,
      lng: 46.6753
    },
    paymentMethod: 'STCPay',
    total: 67.5,
    prescriptionSource: 'wasfaty' as const,
    wasfatyNumber: 'WF-2023-009876',
    trackingHistory: [{
      status: 'Delivered',
      timestamp: '2023-12-20T16:00:00',
      description: 'Package delivered successfully'
    }, {
      status: 'Out for Delivery',
      timestamp: '2023-12-20T12:00:00',
      description: 'Package is out for delivery'
    }]
  }, {
    id: '#RX-2025-00118',
    date: '2023-12-15',
    status: 'delivered',
    items: [{
      name: 'Levothyroxine 50mcg',
      quantity: 30,
      price: 98.25,
      image: PRODUCT_IMAGES[3]
    }, {
      name: 'Calcium Tablets',
      quantity: 60,
      price: 100.0,
      image: PRODUCT_IMAGES[4]
    }],
    doctor: 'Dr. Omar Ali',
    deliveryAddress: 'Riyadh, Al Malqa District, King Fahd Road',
    deliveryCoordinates: {
      lat: 24.7136,
      lng: 46.6753
    },
    paymentMethod: 'Mada',
    total: 198.25,
    prescriptionSource: 'insurance' as const,
    insuranceProvider: 'Tawuniya',
    trackingHistory: [{
      status: 'Delivered',
      timestamp: '2023-12-15T14:00:00',
      description: 'Package delivered successfully'
    }, {
      status: 'Out for Delivery',
      timestamp: '2023-12-15T10:30:00',
      description: 'Package is out for delivery'
    }]
  }];
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'delivered':
        return <CheckCircleIcon className="w-5 h-5 text-green-600" data-id="element-6066" data-mp="2i1muwwtelucn" />;
      case 'ready':
        return <PackageIcon className="w-5 h-5 text-blue-600" data-id="element-6067" data-mp="1cpr9il4univ" />;
      case 'in-progress':
        return <ClockIcon className="w-5 h-5 text-amber-600" data-id="element-6068" data-mp="3te5s06q7fngo" />;
      default:
        return <XCircleIcon className="w-5 h-5 text-red-600" data-id="element-6069" data-mp="1qt35tpl5japh" />;
    }
  };
  const getStatusText = (status: string) => {
    switch (status) {
      case 'delivered':
        return 'Delivered';
      case 'ready':
        return 'Ready';
      case 'in-progress':
        return 'In Progress';
      default:
        return 'Rejected';
    }
  };
  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'delivered':
        return 'bg-green-100 text-green-700';
      case 'ready':
        return 'bg-blue-100 text-blue-700';
      case 'in-progress':
        return 'bg-amber-100 text-amber-700';
      default:
        return 'bg-red-100 text-red-700';
    }
  };
  const getStatusAccent = (status: string) => {
    switch (status) {
      case 'delivered':
        return 'bg-green-500';
      case 'ready':
        return 'bg-blue-500';
      case 'in-progress':
        return 'bg-amber-500';
      default:
        return 'bg-red-500';
    }
  };
  // Status pill counts for mobile
  const statusCounts = {
    all: allPrescriptions.length,
    'in-progress': allPrescriptions.filter(p => p.status === 'in-progress').length,
    ready: allPrescriptions.filter(p => p.status === 'ready').length,
    delivered: allPrescriptions.filter(p => p.status === 'delivered').length
  };
  const statusPills: {
    key: string;
    label: string;
  }[] = [{
    key: 'all',
    label: 'All'
  }, {
    key: 'in-progress',
    label: 'In Progress'
  }, {
    key: 'ready',
    label: 'Ready'
  }, {
    key: 'delivered',
    label: 'Delivered'
  }];
  const filteredPrescriptions = allPrescriptions.filter(prescription => {
    const matchesSearch = prescription.id.toLowerCase().includes(searchQuery.toLowerCase()) || prescription.items.some(item => item.name.toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesStatus = statusFilter === 'all' || prescription.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  const handlePrescriptionClick = (prescription: any) => {
    setSelectedPrescription(prescription);
    setIsModalOpen(true);
  };
  return <HelmetProvider data-id="element-6070" data-mp="2wkc5kk186p6n">
      <SEO title="Prescription History & Orders" description="View and track all your prescription orders. Check delivery status, reorder medications, and manage your prescription history in one convenient place." canonical="/en/prescription/history" hreflangAr="/prescription/history" hreflangEn="/en/prescription/history" hreflangDefault="/prescription/history" keywords="prescription history, order tracking, medication orders, prescription management, reorder medications, delivery status, prescription tracking Saudi Arabia" data-id="element-6071" data-mp="2wkvoa2yp9hlq" />
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-6072" data-mp="1l5q8pydgzokp">
        {/* Desktop Header */}
        <div className="hidden md:block" data-id="element-6073" data-mp="1g6vr2zr8o626">
          <AnnouncementBar data-id="element-6074" data-mp="1g86v90oljftt" />
          <MobileDeliverToPill selectedLocation={selectedLocation} onOpenLocationModal={() => setLocationModalOpen(true)} data-id="element-6075" data-mp="3rsnunfkt26nk" />
          <Header locationModalOpen={locationModalOpen} setLocationModalOpen={setLocationModalOpen} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} data-id="element-6076" data-mp="m3c6k8tg725" />
        </div>
        <main className="flex-grow pt-[var(--header-height-mobile)] md:pt-[var(--header-height-desktop)]" data-id="element-6077" data-mp="392g8a95bruu2">
          <h1 className="sr-only" data-id="element-6078" data-mp="3d5ck9h0d0sp1">Prescription History & Order Tracking</h1>
          {/* Mobile Header Overlay */}
          <MobileInternalHeader title="Prescription History" data-id="element-6079" data-mp="2z5tm9h19ixqg" />
          <PageHeroBreadcrumb breadcrumbs={[{
          label: 'Home',
          href: '/'
        }, {
          label: 'Prescription History'
        }]} title="Prescription History" description="View and track all your prescription orders, including current and past prescriptions." data-id="element-6080" data-mp="3433a4s9071c6" />
          <div className="container mx-auto px-3 md:px-8 lg:px-12 py-3 md:py-8" data-id="element-6081" data-mp="vvqcu1s320kq">
            {/* Search — sticky on mobile under header */}
            <div className="md:hidden sticky top-[56px] z-30 -mx-3 px-3 py-2 bg-gray-50/95 backdrop-blur-sm border-b border-gray-200" data-id="element-6082" data-mp="qx5d03gqtiwt">
              <div className="relative" data-id="element-6083" data-mp="1jlaxcp3vx5w4">
                <SearchIcon className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-6084" data-mp="1jk9a7m9lgsy1" />
                <input type="text" placeholder="Search prescriptions or meds…" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-6085" data-mp="1ensoeypvaqo4" />
              </div>
              {/* Status pills */}
              <div className="flex gap-2 overflow-x-auto scrollbar-hide mt-2 -mx-1 px-1" data-id="element-6086" data-mp="25urcpyl7ov4z">
                {statusPills.map(pill => {
                const isActive = statusFilter === pill.key;
                const count = (statusCounts as any)[pill.key];
                return <button key={pill.key} onClick={() => setStatusFilter(pill.key)} className={`flex-shrink-0 px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-colors ${isActive ? 'bg-[#1E2B55] text-white' : 'bg-white text-gray-700 border border-gray-200'}`} data-id="element-6087" data-mp="2ju0wf88mm7dp">
                      {pill.label}
                      <span className={`ml-1.5 ${isActive ? 'opacity-80' : 'text-gray-400'}`} data-id="element-6088" data-mp="32j77qa73bwph">
                        {count}
                      </span>
                    </button>;
              })}
              </div>
            </div>
            {/* Desktop Filters */}
            <div className="hidden md:block bg-white rounded-xl shadow-md p-6 mb-6" data-id="element-6089" data-mp="d2cdockmhrsz">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6090" data-mp="852gubuwmdv4">
                <div className="relative" data-id="element-6091" data-mp="mt713k9luxg0">
                  <SearchIcon className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6092" data-mp="mwbhdg0chjn1" />
                  <input type="text" placeholder="Search by prescription ID or medication..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-6093" data-mp="3qaxpbtkplrwd" />
                </div>
                <div className="relative" data-id="element-6094" data-mp="1ejtnyxameuxl">
                  <FilterIcon className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6095" data-mp="1ajt9jcniujqj" />
                  <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent appearance-none" data-id="element-6096" data-mp="1i2su3lmpyhbh">
                    <option value="all" data-id="element-6097" data-mp="1d4r7wrtzy1vs">All Status</option>
                    <option value="delivered" data-id="element-6098" data-mp="20ta96nempeed">Delivered</option>
                    <option value="ready" data-id="element-6099" data-mp="20w65k7atvv0p">Ready</option>
                    <option value="in-progress" data-id="element-6100" data-mp="25rvakq5ma44e">In Progress</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Prescriptions List */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mt-3 md:mt-0" data-id="element-6101" data-mp="1w21wnii05cwz">
              {filteredPrescriptions.map(prescription => {
              const itemCount = prescription.items.reduce((s, i) => s + i.quantity, 0);
              return <button key={prescription.id} onClick={() => handlePrescriptionClick(prescription)} className="relative bg-white rounded-2xl shadow-sm md:shadow-md overflow-hidden active:scale-[0.99] hover:shadow-lg hover:border-[#1E2B55] border border-gray-100 transition-all text-left" data-id="element-6102" data-mp="2yeuzrrpfzpud">
                    {/* Mobile-optimized scannable layout */}
                    <div className="md:hidden flex" data-id="element-6103" data-mp="2apsiikypzz0e">
                      {/* Status accent bar */}
                      <div className={`w-1 ${getStatusAccent(prescription.status)}`} data-id="element-6104" data-mp="25qpcax707mqu" />
                      <div className="flex-1 p-3.5" data-id="element-6105" data-mp="21px3u65yhlvm">
                        {/* Top row: status + date */}
                        <div className="flex items-center justify-between mb-2" data-id="element-6106" data-mp="1wozlntky4ru4">
                          <div className="flex items-center gap-1.5" data-id="element-6107" data-mp="1rqobfhqqofbd">
                            {getStatusIcon(prescription.status)}
                            <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${getStatusBadgeClass(prescription.status)}`} data-id="element-6108" data-mp="78dr3lticj83">
                              {getStatusText(prescription.status)}
                            </span>
                          </div>
                          <span className="text-[11px] text-gray-500" data-id="element-6109" data-mp="3kns9aiue8h5k">
                            {new Date(prescription.date).toLocaleDateString('en-US', {
                          month: 'short',
                          day: 'numeric'
                        })}
                          </span>
                        </div>
                        {/* RX ID */}
                        <p className="text-[15px] font-bold text-gray-900 leading-tight" data-id="element-6110" data-mp="31v7vm8n9mimc">
                          {prescription.id}
                        </p>
                        <p className="text-xs text-gray-500 mt-0.5" data-id="element-6111" data-mp="1zcmowsp6c7v6">
                          {prescription.doctor}
                        </p>
                        {/* Item thumbnails + count */}
                        <div className="flex items-center gap-2 mt-2.5" data-id="element-6112" data-mp="29asnb0bruvva">
                          <div className="flex -space-x-2" data-id="element-6113" data-mp="24a506pqnyz6c">
                            {prescription.items.slice(0, 3).map((item, idx) => <img key={idx} src={item.image} alt="" className="w-8 h-8 rounded-full border-2 border-white object-cover bg-gray-100" data-id="element-6114" data-mp="2i8uyg8p7z4wa" data-mpi={idx} />)}
                          </div>
                          <span className="text-xs text-gray-600 truncate" data-id="element-6115" data-mp="3105nslfar9m2">
                            {prescription.items.length} med
                            {prescription.items.length > 1 ? 's' : ''} ·{' '}
                            {itemCount} units
                          </span>
                        </div>
                        {/* Bottom: total + chevron */}
                        <div className="flex items-end justify-between mt-2.5 pt-2.5 border-t border-gray-100" data-id="element-6116" data-mp="36n7qkerrl55q">
                          <div data-id="element-6117" data-mp="3bliyul2ev7lu">
                            <p className="text-[10px] text-gray-500 uppercase tracking-wider" data-id="element-6118" data-mp="3bkhcvljux0pc">
                              Total
                            </p>
                            <p className="text-base font-bold text-[#1E2B55]" data-id="element-6119" data-mp="31oefeszy9q8q">
                              SAR {prescription.total.toFixed(2)}
                            </p>
                          </div>
                          <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-6120" data-mp="2rxa17vi3m9ey" />
                        </div>
                      </div>
                    </div>
                    {/* Desktop layout — unchanged */}
                    <div className="hidden md:block p-6 h-full" data-id="element-6121" data-mp="2iw225b7rd4jt">
                      <div className="flex flex-col h-full" data-id="element-6122" data-mp="2i1gc7433p0w4">
                        <div className="flex items-start justify-between mb-4" data-id="element-6123" data-mp="2i42il0e99acr">
                          <h3 className="text-lg font-bold text-gray-900" data-id="element-6124" data-mp="2m54iljfzxqfs">
                            {prescription.id}
                          </h3>
                          <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusBadgeClass(prescription.status)}`} data-id="element-6125" data-mp="2d2n09g3gphy2">
                            {getStatusText(prescription.status)}
                          </span>
                        </div>
                        <div className="space-y-3 flex-grow" data-id="element-6126" data-mp="2r1uya5nw2k0o">
                          <div data-id="element-6127" data-mp="2w1hdulr6wccn">
                            <p className="text-xs text-gray-500 mb-1" data-id="element-6128" data-mp="2w0g18cuizhst">Date</p>
                            <p className="text-sm font-medium text-gray-900" data-id="element-6129" data-mp="3jr1wt4ncf9lx">
                              {new Date(prescription.date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                            </p>
                          </div>
                          <div data-id="element-6130" data-mp="1huuh12w9cyet">
                            <p className="text-xs text-gray-500 mb-1" data-id="element-6131" data-mp="1hukwhutzfjgi">Doctor</p>
                            <p className="text-sm font-medium text-gray-900" data-id="element-6132" data-mp="u4qobqklyj2l">
                              {prescription.doctor}
                            </p>
                          </div>
                          <div data-id="element-6133" data-mp="135ognblop25c">
                            <p className="text-xs text-gray-500 mb-1" data-id="element-6134" data-mp="132smzzgvczmp">Items</p>
                            <p className="text-sm text-gray-700 line-clamp-2" data-id="element-6135" data-mp="y48zhummnfs8">
                              {prescription.items.map(item => item.name).join(', ')}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200" data-id="element-6136" data-mp="179vvl1cgqxos">
                          <div data-id="element-6137" data-mp="1g87tzpjkmzrs">
                            <p className="text-xs text-gray-500 mb-1" data-id="element-6138" data-mp="1g9am20smr89a">Total</p>
                            <p className="text-xl font-bold text-[#1E2B55]" data-id="element-6139" data-mp="1l7u9k5mvgs3r">
                              SAR {prescription.total.toFixed(2)}
                            </p>
                          </div>
                          <ChevronRightIcon className="w-6 h-6 text-gray-400" data-id="element-6140" data-mp="si57doyfem0k" />
                        </div>
                      </div>
                    </div>
                  </button>;
            })}
            </div>
            {filteredPrescriptions.length === 0 && <div className="bg-white rounded-xl shadow-sm md:shadow-md p-8 md:p-12 text-center mt-3" data-id="element-6141" data-mp="4tc9vo25o63u">
                <PackageIcon className="w-12 h-12 md:w-16 md:h-16 text-gray-300 mx-auto mb-3 md:mb-4" data-id="element-6142" data-mp="9rnf1lhi9sfq" />
                <h3 className="text-base md:text-xl font-bold text-gray-900 mb-1.5 md:mb-2" data-id="element-6143" data-mp="28wcfitafqcu">
                  No prescriptions found
                </h3>
                <p className="text-sm text-gray-600" data-id="element-6144" data-mp="3tcupak1y5kio">
                  Try adjusting your search or filter criteria
                </p>
              </div>}
          </div>
        </main>
        <Footer data-id="element-6145" data-mp="3kgbzhgp0icqb" />
        <MobileFooterNav data-id="element-6146" data-mp="3ff67xm738vid" />
        <PharmacistChat data-id="element-6147" data-mp="3fffx57kb6yn0" />
        <div className="h-16 md:hidden" data-id="element-6148" data-mp="3ffy0eo5e2d4f"></div>
        {selectedPrescription && <PrescriptionDetailsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} prescription={selectedPrescription} data-id="element-6149" data-mp="3anepjyy35w3b" />}
      </div>
    </HelmetProvider>;
}